'use client';

import { useEffect, useLayoutEffect } from 'react';
import { Product } from 'shared/types/product/Product';
import ProductDetailsAdapter from 'components/commercetools-ui/organisms/product/product-details/helpers/adapter';
import { DataSource } from 'types/datasource';
import { TasticProps } from 'frontastic/tastics/types';
import { useAccount } from 'frontastic/hooks';
import { DataLayerOnLoad } from 'helpers/dataLayerHelpers';
import useLocale from 'helpers/hooks/useLocale';
import { ImageProps } from 'frontastic/lib/image';
import { redirect, useRouter } from 'next/navigation';
import NotFound from 'components/commercetools-ui/organisms/not-found';

const ProductDetailsTastic = ({ data }: TasticProps<DataSource<{ product: Product }>>) => {
  const product = data?.data?.dataSource?.product;
  if (!product) {
    return redirect('/404');
  }
  const router = useRouter();
  if (!product) return null;
  const { getCountry, getCurrency } = useLocale();
  const { account } = useAccount();
  const { _url: productUrl = '' } = product;

  useEffect(() => {
    const localeData = {
      country: getCountry(),
      currency: getCurrency(),
    };
    const currentUrl = document.location.origin;
    const dataLayer = new DataLayerOnLoad(currentUrl, 'product', localeData, account);
    dataLayer.setDataLayerOnLoad();
  }, []);
  // const normalizedProductUrl = productUrl?.replace(/^\/\//, '/');
  // useLayoutEffect(() => {
  //   if (normalizedProductUrl && !window.location.href.includes(normalizedProductUrl)) {
  //     router.replace(normalizedProductUrl);
  //   }
  // }, [normalizedProductUrl]);

  // useLayoutEffect(() => {
  //   if (productUrl && !window.location.href.includes(productUrl)) {
  //     router.replace(productUrl);
  //   }
  // }, [productUrl]);

  return <ProductDetailsAdapter product={product} productLogo={data?.productLogo?.media?.file} />;
};

export default ProductDetailsTastic;
